import React, { useEffect } from "react";
import useGiftCard from "./hooks/useGiftCard";
import SingleGiftCard from "./single-gift-card";
import "./style.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { State } from "../../store";

const GiftCard: React.FC = () => {
  const { acceptTransaction, tickets } = useGiftCard();
  const { t } = useTranslation();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  useEffect(() => {
    acceptTransaction();
  }, []);

  return (
    <div>
      <div className="headline">
        {saleConfiguration.componentList && (
          <React.Fragment>
            {saleConfiguration.componentList.map((item) => (
              <React.Fragment>{item.id === "GiftCardActive" && <h1>{item.name}</h1>}</React.Fragment>
            ))}
          </React.Fragment>
        )}
        <div className="line"></div>
        {saleConfiguration.message_giftCards && (
          <React.Fragment>
            {saleConfiguration.message_giftCards.length > 12 ? (
              <div className="alert alert-comment">
                <article dangerouslySetInnerHTML={{ __html: saleConfiguration.message_giftCards }}></article>
              </div>
            ) : (
              <React.Fragment></React.Fragment>
            )}
          </React.Fragment>
        )}

      </div>
      <div className="flex-between flex-wrap">
        {tickets.length > 0 ? (
          <React.Fragment>
            {tickets.map((item, index) => (
              <SingleGiftCard item={item} key={index} />
            ))}
          </React.Fragment>
        ) : (
          <div className="alert alert-yellow">
            <b>{t("brak_aktywnych_kart_podarunkowych")}</b>
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftCard;
